import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import CustomSelect from '../../../../common/CustomReactSelectComponent'
import { closeModal } from '../../../../common/GlobalModal/redux/GlobalModalActions'
import { notificationDanger } from '../../../../utils/customToastify'

const AssignSalespersonModal = ({ selectedApplications, salespersons, onAssign }) => {
  const dispatch = useDispatch()
  const [selectedSalesperson, setSelectedSalesperson] = useState(null)

  const handleSalespersonChange = (value) => {
    setSelectedSalesperson(value ? value.id : null)
  }

  const handleAssign = async () => {
    if (!selectedSalesperson) {
      notificationDanger('Please select a salesperson')
      return
    }

    await onAssign(selectedSalesperson)
    dispatch(closeModal('assign_salesperson_modal'))
  }

  const handleCancel = () => {
    dispatch(closeModal('assign_salesperson_modal'))
  }

  return (
    <>
      <Row>
        <Col>
          <p>
            Assigning <strong>{selectedApplications?.length || 0}</strong> application(s) to a salesperson.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <CustomSelect
            options={Array.isArray(salespersons) ? salespersons : []}
            onChange={handleSalespersonChange}
            defaultValue={selectedSalesperson}
            label='Select Salesperson'
            placeholder='Please Select...'
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex justify-content-end'>
          <Button className='btn btn-gold btn-sm mr-2' onClick={handleAssign} disabled={!selectedSalesperson}>
            Assign
          </Button>
          <Button className='btn btn-sm' color='danger' onClick={handleCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default AssignSalespersonModal

